export default __webpack_public_path__ + "static/media/480_store01-fr-mobile.a8ad641c.png";